import { useCajaContext } from "@/features/cajas/caja-actual/contexts/caja-context";
import ViewCajaActualHistorialModal from "./view-caja-actual-historial-modal";
import CajaUnassigned from "./caja-unassigned";
import CajaClosed from "./caja-closed";
import CajaOpened from "./caja-opened";
import OpenCajaModal from "./open-caja-modal";
import CloseCajaModal from "./close-caja-modal";

export default function CajaActualPage() {
    const { cajaData } = useCajaContext();

    const renderContent = () => {
        if (!cajaData) return <CajaUnassigned />
        else if (!cajaData.abierto) return <CajaClosed />
        else return <CajaOpened />
    }

    return <>
        {renderContent()}
        <OpenCajaModal code="openCaja" />
        <CloseCajaModal code="closeCaja" />
        <ViewCajaActualHistorialModal code="viewHistorialCajaActual" />
    </>
}